<template>
  <div class="container" ref="cont">
    <el-page-header class="page-header" @back="goBack" :content="title">
    </el-page-header>
    <div class="contact-container">
      <el-input class="input-circle" v-model="searchText" placeholder="请输入患者姓名或出生日期">
        <img slot="suffix" class="el-input-icon" src="../../../static/image/ic_search.png" @click="search"></img>
      </el-input>
      <el-button class="btn-add-contact" icon="el-icon-plus" @click="contactDialogVisible = true">添加患者信息</el-button>
    </div>
    <div class="search-container" v-show="searchTableVisible">
      <el-table class="search-table" :data="searchArray" :show-header="showHeader" max-height=290
        @row-click="tableItemClick">
        <el-table-column width="160" property="name" label="姓名"></el-table-column>
        <el-table-column width="160" property="phoneNo" label="电话"></el-table-column>
        <el-table-column width="160" property="birthday" label="出生日期"></el-table-column>
      </el-table>
      <el-pagination v-if="totalPage > 10" class="pagination" background layout="prev, pager, next"
        :current-page="currentPageNo" @current-change="pageChange" :total="totalPage">
      </el-pagination>
    </div>
    <ul class="select-contact" v-if="selectContactVisible">
      <li>姓名：{{selectContact.name}}</li>
      <li>性别：{{selectContact.sex == '0'?'女':'男'}}</li>
      <li>电话：{{selectContact.phoneNo}}</li>
      <li>出生日期：{{selectContact.birthday}}</li>
      <li>常住地址：{{selectContact.liveArea}}</li>
      <li>出生地址：{{selectContact.birthArea}}</li>
    </ul>
    <span>使用信息</span>
    <div>
      <el-date-picker class="input-circle" v-model="useDate" size="large" @change="useDateChange" :editable="editable"
        prefix-icon="none" placeholder="请选择开始服药日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date">
      </el-date-picker>
    </div>
    <div>
      <el-input @wheel.native.prevent class="input-circle input-margin" v-model="useDays" placeholder="请输入服药天数（不大于30天）" type="number"></el-input>
    </div>
    <div>
      <el-button class="btn-confirm" type="primary" @click="consult">开始咨询</el-button>
    </div>
    <el-dialog title="添加患者信息" :visible.sync="contactDialogVisible" width="800px" center custom-class="contact-dialog"
      destroy-on-close :close-on-click-modal="dialogClose">
      <div class="dialog-wrapper">
        <el-form :model="addContactForm" label-width="100px" label-position="left" class="dialog-form">
          <el-form-item label="*姓名">
            <el-input v-model="addContactForm.name" autocomplete="off" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="*性别">
            <el-radio-group v-model="addContactForm.sex">
              <el-radio-button class="radio-button-one" label="1" size="medium">男</el-radio-button>
            </el-radio-group>
            <el-radio-group v-model="addContactForm.sex">
              <el-radio-button label="0" size="medium">女</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="addContactForm.phoneNo" autocomplete="off" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="*出生日期">
            <el-input v-model="addContactForm.displayBirth" autocomplete="off" placeholder="请选择出生日期" @focus="showBirthdayDialog"></el-input>
            <!-- <j-date-picker
                    v-model="birthday"
                    width="800"
                     :rangeSeparator="rangeSeparator"
                     @change="birthDateChange"
                     :showLunarClass="showLunarClass"
                     :showLunarControl="true"
                     placeholder="请选择出生日期"
                     type="DATE"
                     :showBackYears="showBackYears"
                     :showLunarIcon="showLunarIcon">
                </j-date-picker> -->
          </el-form-item>
          <span style="color: #dd3131;font-size: 16px;margin-left: 100px;">在本系统其他页面，只展示阳历（公历）生日。</span>
          <el-form-item label="*常住地址">
            <el-cascader class="address-picker" placeholder="选择或根据省市区搜索常住地址" v-model="addContactForm.liveArea" :filterable="true" :options="areaOptions">
            </el-cascader>
          </el-form-item>
          <el-form-item label="*出生地址">
            <el-cascader class="address-picker2" placeholder="选择或根据省市区搜索出生地址" v-model="addContactForm.birthArea" :filterable="true" :options="areaOptions">
            </el-cascader>
            <el-button v-show="copyVisible" style="margin-left: 20px;" type="success" plain @click="copyAddress" size="small" round>和常住地一致</el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="btn-dialog-cancel" @click="contactDialogVisible = false">取 消</el-button>
          <el-button class="btn-dialog-confirm" type="primary" :loading="dialogBtnLoading" @click="addContactConfirm">添
            加</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      title="选择出生日期"
      :close-on-press-escape="false"
      :visible.sync="birthdayDialogShow"
      width="800px"
      center>
      <div class="dialog-wrapper">
        <el-radio-group v-model="currentDateType">
          <el-radio-button label="0">阳历(公历)</el-radio-button>
          <el-radio-button label="1">阴历(农历)</el-radio-button>
        </el-radio-group>
        <span style="font-size: 20px;margin-top: 20px;">{{currentDateType == 0?'阳历(公历)':'阴历(农历)'}}</span>
        <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 30px;">
          <el-select style="width: 100px;" v-model="currentYear" placeholder="年份" @visible-change="handleYearVisibleChange" ref="selectYearRef">
            <el-option
              v-for="item in years"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <span style="margin-left: 10px;margin-right: 40px;font-size: 18px;">年</span>
          <el-select style="width: 100px;" v-model="currentMonth" placeholder="月份" @visible-change="handleMonthVisibleChange" ref="selectMonthRef">
              <el-option
                v-for="item in months"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            <span style="margin-left: 10px;margin-right: 40px;font-size: 18px;">月</span>
            <el-select style="width: 100px;" v-model="currentDay" placeholder="日期" @visible-change="handleDayVisibleChange" ref="selectDayRef">
                <el-option
                  v-for="item in days"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
              <span style="margin-left: 10px;margin-right: 40px;font-size: 18px;" v-show="currentDateType == '0'">日</span>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button class="btn-dialog-cancel" @click="birthdayDialogShow = false">取 消</el-button>
            <el-button class="btn-dialog-confirm" type="primary" @click="setBirthdayData">确 定</el-button>
        </span>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import store from '../../store'
  import date from '../../js/date'
  import calendar from 'js-calendar-converter'
  export default {
    name: "addPrescriptionContact",
    data() {
      return {
        years:[],
        months:[],
        days:[],
        currentYear:"",
        currentMonth:"",
        currentDay:"",
        currentDateType:"0",
        birthdayDialogShow:false,
        format:'YYYY-MM-DD',
        rangeSeparator:'-',
        isLunar:false,
        title:"",
        useDate: '',
        editable: false,
        useDays: '',
        showHeader: true,
        searchArray: [],
        searchTableVisible: false,
        selectContact: {},
        searchText: '',
        addContactForm: {
          name: '',
          sex: '1',
          phoneNo: '',
          birthday: '',
          birthArea: '',
          liveArea: ''
        },
        contactDialogVisible: false,
        dialogClose: false,
        copyVisible:false,
        selectContactVisible: false,
        dialogBtnLoading: false,
        area: {},
        totalPage: 1,
        currentPageNo: 1,
        pageSize: 5,
        mode: 1,
      }
    },
    computed: {
        areaOptions() {
            var area = this.$store.state.areaInfo;
            if(!area || !Array.isArray(area.province_list)) return [];
            
            var provinces = [];
            var citiesMap = {}; 
            var countiesMap = {}; 
            
            // 1. Prepare Counties
            if(area.county_list){
                area.county_list.forEach(county => {
                    var cCode = county.parentAreaCode;
                    if(!countiesMap[cCode]) countiesMap[cCode] = [];
                    countiesMap[cCode].push({
                        value: county.areaCode,
                        label: county.name
                    });
                });
            }
            
            // 2. Prepare Cities
            if(area.city_list){
                area.city_list.forEach(city => {
                    var pCode = city.parentAreaCode;
                    if(!citiesMap[pCode]) citiesMap[pCode] = [];
                    
                    var cityNode = {
                        value: city.areaCode,
                        label: city.name
                    };
                    if(countiesMap[city.areaCode] && countiesMap[city.areaCode].length > 0) {
                        cityNode.children = countiesMap[city.areaCode];
                    }
                    citiesMap[pCode].push(cityNode);
                });
            }
            
            // 3. Prepare Provinces
            if(area.province_list){
                area.province_list.forEach(province => {
                    var pCode = province.areaCode;
                    var provinceNode = {
                        value: pCode,
                        label: province.name
                    };
                    if(citiesMap[pCode] && citiesMap[pCode].length > 0) {
                        provinceNode.children = citiesMap[pCode];
                    }
                    provinces.push(provinceNode);
                });
            }
            return provinces;
        }
    },
    created() {
      this.mode = this.$route.query.mode
      this.title = this.mode == 1?"中药组方":"自拟组方"
      //从患者列表过来的
      var contact = sessionStorage.getItem('contactList')
      console.log("created")
      var consultInfo = sessionStorage.getItem("consultInfo")
      if (!this.utils.isEmptyStr(contact)) {
        this.selectContact = JSON.parse(contact)
        this.selectContactVisible = true
        this.useDate = ''
        this.useDays = ''
        sessionStorage.removeItem('contactList')
        sessionStorage.removeItem('submitData')
        sessionStorage.removeItem('consultInfo')
        sessionStorage.removeItem('patient')
        sessionStorage.removeItem('visitRecordId')
      } else {
        if (this.utils.isEmptyStr(consultInfo)) {
          this.useDate = ''
          this.useDays = ''
          this.selectContact = {},
            this.dialogClose = false
          this.selectContactVisible = false
        } else {
          this.selectContact = JSON.parse(consultInfo)
          this.useDate = this.selectContact.useDate
          this.useDays = this.selectContact.useDays
          this.selectContactVisible = true
        }
      }
      this.searchTableVisible = false
      this.searchArray = []
      this.searchText = ''
      this.addContactForm = {
        name: '',
        sex: '1',
        phoneNo: '',
        birthday: '',
        birthArea: '',
        liveArea: ''
      }
      this.contactDialogVisible = false
      this.dialogBtnLoading = false
    },
    mounted() {
        this.area = this.$store.state.areaInfo
    },
    methods: {
      handleWheel(event) {
        console.log(event)
        // 阻止滚轮事件的默认行为
        // event.preventDefault();
      },
      handleYearVisibleChange(visible) {
        if (visible) {
          this.$nextTick(() => {
            const selectedIndex = this.years.findIndex(
              (option) => option == this.currentYear
            );
            if (selectedIndex >= 0) {
              const selectDropdown = this.$refs.selectYearRef.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
              const dropdownList = selectDropdown.querySelectorAll('li');
              dropdownList.forEach((item)=>{
                item.classList.remove("selected");
              })
              dropdownList[selectedIndex].classList.add("selected")
              if (selectDropdown) {
                var scrollTop = 0
                if(selectedIndex > 6){
                  scrollTop = 34*(selectedIndex-6)
                }
                selectDropdown.scrollTop = scrollTop
              }
            }
          });
        }
      },
      handleMonthVisibleChange(visible) {
        if (visible) {
          this.$nextTick(() => {
            const selectedIndex = this.months.findIndex(
              (option) => option == this.currentMonth
            );
            if (selectedIndex >= 0) {
              const selectDropdown = this.$refs.selectMonthRef.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
              const dropdownList = selectDropdown.querySelectorAll('li');
              dropdownList.forEach((item)=>{
                item.classList.remove("selected");
              })
              dropdownList[selectedIndex].classList.add("selected")
              if (selectDropdown) {
                var scrollTop = 0
                if(selectedIndex > 6){
                  scrollTop = 34*(selectedIndex-6)
                }
                selectDropdown.scrollTop = scrollTop
              }
            }
          });
        }
      },
      handleDayVisibleChange(visible) {
        if (visible) {
          this.$nextTick(() => {
            const selectedIndex = this.days.findIndex(
              (option) => option == this.currentDay
            );
            if (selectedIndex >= 0) {
              const selectDropdown = this.$refs.selectDayRef.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
              const dropdownList = selectDropdown.querySelectorAll('li');
              dropdownList.forEach((item)=>{
                item.classList.remove("selected");
              })
              dropdownList[selectedIndex].classList.add("selected")
              if (selectDropdown) {
                var scrollTop = 0
                if(selectedIndex > 6){
                  scrollTop = 34*(selectedIndex-6)
                }
                selectDropdown.scrollTop = scrollTop
              }
            }
          });
        }
      },
      showBirthdayDialog(){
        var birthdayArray = []
        if(this.addContactForm.birthday){
          birthdayArray = this.addContactForm.birthday.split('-')
        }else{
          birthdayArray = ['2000','06','15']
        }
        this.years = date.years()
        this.months = date.glMonths()
        this.days = date.glDays(birthdayArray[0],birthdayArray[1])
        this.currentYear = birthdayArray[0]
        this.currentMonth = birthdayArray[1]
        this.currentDay = birthdayArray[2]
        this.birthdayDialogShow = true
      },
      setBirthdayData(){
        if(!this.currentYear){
          this.$message("请选择出生年份")
          return
        }
        if(!this.currentMonth){
          this.$message("请选择出生月份")
          return
        }
        if(!this.currentDay){
          this.$message("请选择出生日期")
          return
        }
        //公历
        if(this.currentDateType == '0'){
          var monthStr = this.currentMonth.length == 1?('0'+this.currentMonth):this.currentMonth
          var dayStr = this.currentDay.length == 1?('0'+this.currentDay):this.currentDay
          var solarDate = this.currentYear+'年'+monthStr+'月'+dayStr+'日'
          var birthday = this.currentYear+'-'+monthStr+'-'+dayStr
          var lunarDateObj = calendar.solar2lunar(this.currentYear,this.currentMonth,this.currentDay)
          console.log(lunarDateObj)
          var flag = this.utils.afterDateFromCurrent(birthday)
          if(flag){
            this.$message({
              message:'出生日期必须小于当前日期',
              type:'warning'
            })
            return
          }
          this.addContactForm.displayBirth = '公历'+solarDate+'  农历'+lunarDateObj.lYear+'年'+lunarDateObj.IMonthCn+lunarDateObj.IDayCn
          this.addContactForm.birthday = birthday
          this.addContactForm.lunarBirthday = lunarDateObj.lYear+'年'+lunarDateObj.IMonthCn+lunarDateObj.IDayCn
        }else{
          var lunarDate = this.currentYear+'年'+this.currentMonth+'月'+this.currentDay
          var monthNum = date.convertLunarMonthToNumeric(this.currentMonth)
          var dayNum = date.convertLunarDayToNumeric(this.currentDay)
          var solarDateObj = calendar.lunar2solar(this.currentYear,parseInt(monthNum),dayNum,this.currentMonth.indexOf('闰')>=0)
          console.log(solarDateObj)
          var monthStr = (solarDateObj.cMonth < 10?('0'+solarDateObj.cMonth):solarDateObj.cMonth)
          var dayStr = solarDateObj.cDay < 10?('0'+solarDateObj.cDay):solarDateObj.cDay
          var solarDate = solarDateObj.cYear+'年'+monthStr+'月'+dayStr+'日'
          var birthday = solarDateObj.cYear+'-'+monthStr+'-'+dayStr
          var flag = this.utils.afterDateFromCurrent(birthday)
          if(flag){
            this.$message({
              message:'出生日期必须小于当前日期',
              type:'warning'
            })
            return
          }
          this.addContactForm.displayBirth = '公历'+solarDate+'  农历'+lunarDate
          this.addContactForm.birthday = birthday
          this.addContactForm.lunarBirthday = lunarDate
        }
        this.birthdayDialogShow = false
        this.currentDateType = '0'
      },
      search() {
        console.log(this.searchText)
        const loading = this.$loading({
          lock: true,
          text: '搜索中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.1)'
        });
        this.wjtHttp.post(this, '/api/patient/v1/list', {
          name: this.searchText.trim(),
          pageNum: this.currentPageNo,
          pageSize: this.pageSize
        }, false, (res) => {
          var data = res.data
          loading.close()
          if (data.code == 200) {
            this.totalPage = Math.ceil(data.total / 5) * 10
            this.searchArray = data.rows
            // for(var i=0;i<this.searchArray.length;i++){
            //   this.searchArray[i].displayBirth = this.searchArray[i].birthday
            //   if(this.searchArray[i].lunarBirthday && this.searchArray[i].lunarBirthday.length > 0){
            //     this.searchArray[i].displayBirth = this.searchArray[i].lunarBirthday
            //   }
            // }
            if (this.searchArray.length > 0) {
              this.searchTableVisible = true
              this.selectContactVisible = false
            } else {
              this.$message({
                message: '未找到该患者，请手动添加',
                type: 'warning'
              })
            }
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '搜索异常，请联系管理员',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
          loading.close();
        })

      },
      copyAddress(){
        var birthAddress = document.getElementsByClassName('address-picker2')
        this.addContactForm.birthArea = this.addContactForm.liveArea
        // birthAddress[0].firstChild.children[0].value = this.addContactForm.birthArea.join(' / ')
      },
      useDateChange(val) {
        console.log(val)
        var flag = this.utils.afterDateFromCurrent(val)
        var yearAfter = this.utils.isAfterOneYear(val)
        setTimeout(() => {
          if (!flag) {
            this.useDate = ''
            this.$message({
              message: '开方日期必须大于当前日期',
              type: 'warning'
            })
          }
          if (yearAfter) {
            this.useDate = ''
            this.$message({
              message: '开方日期必须在一年以内',
              type: 'warning'
            })
          }
        }, 100)
      },
      birthDateChange(val) {
        var dateStr = val
        var flag = this.utils.afterDateFromCurrent(dateStr)
        if (flag) {
          this.addContactForm.birthday = ''
          this.$message({
            message: '出生日期必须小于当前日期',
            type: 'warning'
          })
        }
      },
      tableItemClick(row, column, event) {
        this.searchTableVisible = false
        this.selectContact = row
      },
      getName(list, code){
        if(!list || !Array.isArray(list)) return '';
        let item = list.find(x => x.areaCode == code);
        return item ? item.name : '';
    },
    addContactConfirm() {
        if (this.addContactForm.name.length == 0) {
            this.$message({
                message: '请输入姓名',
                type: 'warning'
            })
            return
        }
        // if(this.addContactForm.phoneNo.length == 0){
        //     this.$message({
        //         message:'请输入手机号码',
        //         type:'warning'
        //     })
        //     return
        // }
        if(!this.addContactForm.birthday || this.addContactForm.birthday.length == 0){
            this.$message({
                message:'请选择出生日期',
                type:'warning'
            })
            return
        }
        // var dateStr = this.addContactForm.birthday
        // if(this.addContactForm.birthday.startsWith("L")){
        //   dateStr = this.birthday.substring(1, this.birthday.length)
        // }
        var minDate = new Date("1900-01-01")
        var currentDate = new Date(this.addContactForm.birthday)
        if(currentDate < minDate){
          this.$message({
              message:'出生日期不能小于1900-01-01',
              type:'warning'
          })
          return
        }
        if (this.addContactForm.liveArea.length == 0) {
          this.$message({
            message: '请选择常住地址',
            type: 'warning'
          })
          return
        }
        if (this.addContactForm.birthArea.length == 0) {
          this.$message({
            message: '请选择出生地址',
            type: 'warning'
          })
          return
        }
        var addContactForm = JSON.parse(JSON.stringify(this.addContactForm))
        var liveArea = addContactForm.liveArea
        var birthArea = addContactForm.birthArea
        if(Array.isArray(addContactForm.liveArea)){
          addContactForm.liveArea = liveArea.map((key, index) => {
            if(index == 0){
              return this.getName(this.area.province_list, key)
            }else if(index == 1){
              return this.getName(this.area.city_list, key)
            }else{
              return this.getName(this.area.county_list, key)
            }
          }).join('');
        }
        if(Array.isArray(addContactForm.birthArea)){
          addContactForm.birthArea = birthArea.map((key, index) => {
            if(index == 0){
              return this.getName(this.area.province_list, key)
            }else if(index == 1){
              return this.getName(this.area.city_list, key)
            }else{
              return this.getName(this.area.county_list, key)
            }
          }).join('');
        }
        this.dialogBtnLoading = true
        this.wjtHttp.post(this, '/api/patient/v1', addContactForm, false, (response) => {
          if (response.data.code == 200) {
            this.wjtHttp.post(this, '/api/patient/v1/list', {
              name: this.addContactForm.name.trim()
            }, false, (res) => {
              this.dialogBtnLoading = false
              var data = res.data
              if (data.code == 200) {
                var searchResult = data.rows
                if (!this.utils.isEmptyStr(searchResult)) {
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  })
                  this.contactDialogVisible = false
                  if (searchResult.length > 1) {
                    this.searchTableVisible = true
                    this.selectContactVisible = false
                    this.searchArray = searchResult
                    this.searchText = this.addContactForm.name
                    this.selectContact = {}
                  } else {
                    this.selectContact = searchResult[0]
                    this.searchText = ''
                    this.searchArray = []
                    this.searchTableVisible = false
                    this.selectContactVisible = true
                  }
                  this.addContactForm = {
                    name: '',
                    sex: '1',
                    phoneNo: '',
                    birthday: '',
                    birthArea: '',
                    liveArea: ''
                  }
                } else {
                  this.$message({
                    message: '添加失败，请联系管理员',
                    type: 'warning'
                  })
                }

              } else {
                this.$message({
                  message: (data.msg && data.msg.length > 0) ? data.msg : '添加异常，请联系管理员',
                  type: 'error'
                })
              }
            }, (err) => {
              console.log(err)
              this.dialogBtnLoading = false
            })
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '添加失败，请联系管理员',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
          this.dialogBtnLoading = false
          this.$message({
            message: (data.msg && data.msg.length > 0) ? data.msg : '添加失败，请联系管理员',
            type: 'error'
          })
        })
      },
      pageChange(pageNo) {
        this.currentPageNo = pageNo
        this.search()
      },
      goBack() {
        if (!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/') {
          this.$router.go(-1)
        } else {
          this.$router.replace('/')
        }
      },
      consult() {
        if (this.utils.isEmptyObject(this.selectContact)) {
          this.$message({
            message: '请先添加患者信息',
            type: 'error'
          })
          return
        }
        if (this.useDate.length == 0) {
          this.$message({
            message: '请选择使用日期',
            type: 'error'
          })
          return
        }
        if (this.useDays.length == 0) {
          this.$message({
            message: '请输入使用天数',
            type: 'error'
          })
          return
        }
        if (parseInt(this.useDays) > 30) {
          this.$message({
            message: '使用天数不能大于30天',
            type: 'error'
          })
          return;
        }
        if (parseInt(this.useDays) <= 0) {
          this.$message({
            message: '使用天数不能小于1天',
            type: 'error'
          })
          return;
        }
        if (isNaN(parseInt(this.useDays))) {
          this.$message({
            message: '请输入整数数字天数',
            type: 'error'
          })
          return;
        }
        sessionStorage.removeItem('visitRecordId')
        var consultInfo = {
          contact: this.selectContact,
          useDate: this.useDate,
          useDays: this.useDays
        }
        this.selectContact.useDate = this.useDate
        this.selectContact.useDays = this.useDays
        console.log(consultInfo)
        // this.$store.commit("updateConsultInfo",JSON.stringify(consultInfo))
        sessionStorage.setItem("consultInfo", JSON.stringify(this.selectContact))
        sessionStorage.removeItem('submitData')
        this.$router.push({
          path:'/prescriptionInfo',
          query:{
            mode:this.mode
          }
        })
      }
    },
    watch: {
      searchTableVisible: function(val) {
        if (!val &&
          !this.utils.isEmptyObject(this.selectContact) &&
          !this.utils.isEmptyStr(this.selectContact.name)) {
          this.selectContactVisible = true
        }
      },
      contactDialogVisible:function(val){
          if(!val){
              this.addContactForm = {
                  name:'',
                  sex:'1',
                  phoneNo:'',
                  birthday:'',
                  birthArea:'',
                  liveArea:''
              }
              this.copyVisible = false
          }
      },
      birthdayDialogShow:function(val){
        if(!val){
          this.years = []
          this.months = []
          this.days = []
          this.currentYear = ''
          this.currentMonth = ''
          this.currentDay = ''
          this.currentDateType = '0'
        }
      },
      currentDateType:function(val){
        this.isDateTypeChanged = true
        if(this.birthdayDialogShow){
          if(val == '0'){ //农历切到公历
            var monthNumeric = date.convertLunarMonthToNumeric(this.currentMonth)
            var dayNumeric = date.convertLunarDayToNumeric(this.currentDay)
            console.log(monthNumeric)
            console.log(this.currentMonth)
            //农历转公历日期
            var solarDate = calendar.lunar2solar(this.currentYear,parseInt(monthNumeric),dayNumeric,this.currentMonth.indexOf('闰')>=0)
            console.log(solarDate)
            this.currentYear = solarDate.cYear
            this.currentMonth = (solarDate.cMonth < 10?('0'+solarDate.cMonth):solarDate.cMonth)
            this.currentDay = (solarDate.cDay < 10?('0'+solarDate.cDay):solarDate.cDay)
            this.months = date.glMonths()
            this.days = date.glDays(solarDate.cYear,solarDate.cMonth)
          }else{ //公历切到农历
            var lunarDate = calendar.solar2lunar(this.currentYear,this.currentMonth,this.currentDay)
            console.log(lunarDate)
            this.currentYear = lunarDate.lYear
            this.currentMonth = lunarDate.IMonthCn.replace('月','')
            this.currentDay = lunarDate.IDayCn
            this.months = date.nlMonths(lunarDate.lYear)
            this.days = date.nlDays(lunarDate.lYear,lunarDate.lMonth,lunarDate.isLeap)
          }
        }
      },
      currentYear:function(val){
        if(val && !this.isDateTypeChanged){
          if(this.currentDateType == '0'){
            if(this.currentMonth){
              this.days = date.glDays(val,this.currentMonth)
            }else{
              this.days = []
            }
            if(this.currentDay && this.currentDay>this.days[this.days.length-1]){
              this.currentDay = ""
            }
          }else{
            this.months = date.nlMonths(val)
            if(this.currentMonth && this.months.some(item => item == this.currentMonth) == false){
              this.currentMonth = ""
              this.currentDay = ''
            }
            if(this.currentMonth){
              this.days = date.nlDays(val,date.convertLunarMonthToNumeric(this.currentMonth),this.currentMonth.indexOf('闰'))
              if(this.currentDay && this.days.some(item => item == this.currentDay) == false){
                this.currentDay = ""
              }
            }else{
              this.days = []
            }
          }
        }
      },
      currentMonth:function(val){
        if(val && !this.isDateTypeChanged){
          if(this.currentDateType == '0'){
            this.days = date.glDays(this.currentYear,val)
            if(this.currentDay && this.currentDay>this.days[this.days.length-1]){
              this.currentDay = ""
            }
          }else{
            this.days = date.nlDays(this.currentYear,date.convertLunarMonthToNumeric(val),val.indexOf('闰')>=0)
            if(this.currentDay && this.days.some(item => item == this.currentDay) == false){
              this.currentDay = ""
            }
          }
        }else{
          this.isDateTypeChanged = false
        }
      },
      'addContactForm.liveArea': {
            handler(newValue, oldValue) {
              if(newValue && newValue.length>0){
                this.copyVisible = true
              }
            },
            // 设置深度监听
            deep: true
          }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.fromPath = from.path
      })
    }
  }
</script>

<style scoped>
  .container {
    width: 1366px;
    height: 660px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #156098;
    background-image: url('../../../static/image/bg_kaifang.png');
    background-size: 100% 100%;
    overflow: auto;
  }
  .el-form-item {
      margin-top: 22px !important;
      margin-bottom: 0px !important;
  }
  .container>span {
    width: 500px;
    font-size: 22px;
    color: #FFFFFF;
    margin-bottom: 22px;
    text-align: left;
    margin-top: 30px;
  }

  .search-container {
    border-radius: 10px;
    background: #FFFFFF;
  }

  .contact-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    position: relative;
    left: 90px;
    margin-bottom: 20px;
  }

  .input-circle {
    width: 500px;
    height: 60px;
  }

  .input-circle>>>input {
    border-radius: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .el-icon-add {
    width: 26px;
    height: 26px;
    margin: 5px;
  }

  .pagination {
    margin-bottom: 20px;
  }

  .input-margin {
    margin-top: 10px;
  }

  .el-input-icon {
    width: 22px;
    height: 22px;
    position: relative;
    top: 10px;
    right: 12px
  }

  .btn-add-contact {
    background: #FFFFFF;
    font-size: 14px;
    margin-left: 15px;
    border-radius: 30px;
    position: relative;
    bottom: 8px;
  }

  .search-table {
    border-radius: 10px;
    width: 480px;
    min-height: 290px;
    position: relative;
    bottom: 20px;
    margin-top: 5px;
  }

  .select-contact {
    margin-bottom: 20px;
    border-radius: 10px;
    background: rgb(213, 223, 222, 0.7);
    border-style: solid;
    border-color: rgb(255, 255, 255, 1);
    border-width: 1px;
    padding: 20px 10px;
    position: relative;
    bottom: 20px;
  }

  .select-contact>li {
    width: 460px;
    text-align: left;
    font-size: 20px;
    line-height: 35px;
    color: #333333;

  }

  .btn-confirm {
    width: 384px;
    border-radius: 40px;
    margin-top: 60px;
    margin-bottom: 60px;
    font-size: 18px;
    height: 45px;
  }

  .contact-dialog {
    border-radius: 10px;
  }

  .dialog-form {
    width: 650px;
  }

  .dialog-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .radio-button-one {
    margin-right: 50px;
  }

  .dialog-picker {
    width: 550px;
  }

  .address-picker {
    width: 550px;
  }
 .address-picker2 {
    width: 550px;
  }
  .page-header {
    width: 1160px;
    margin-top: 30px;
    color: white;
    font-size: 20px;
  }

  .page-header>>>div {
    color: white;
    font-size: 20px;
  }

  .btn-dialog-cancel {
    margin-right: 50px;
    width: 150px;
    border-radius: 30px;
    margin-top: 30px;
  }

  .btn-dialog-confirm {
    margin-left: 50px;
    width: 150px;
    border-radius: 30px;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/kaifang/addPrescriptionContact.vue